export default __webpack_public_path__ + "static/media/7.52207d0e.png";